const initialState = {
  actionProcessing: false,
  general: {
    balance: 0,
    incomeToday: 0,
  },
  users: {
    totalPlayers: 0,
    totalCashiers: 0,
    totalAdmins: 0,
    playersRegisteredToday: 0,
  },
  transfers: {
    depositsSum: 0,
    withdrawalsSum: 0,
    total: 0,
    depositsCount: 0,
    withdrawalsCount: 0,
  },
  bets: {
    totalBetAmount: 0,
    totalWinnings: 0,
    totalGgr: 0,
    totalBetsCount: 0,
  },
};

export default initialState;
